var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, CustomElement, ViewChild, Components, Utils } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
let PacemTickerElement = class PacemTickerElement extends Components.PacemSafeContentElement {
    constructor() {
        super(...arguments);
        this._contentChangeHandler = (evt) => {
            this._incoming.replaceChildren(...this.#newContent);
            Utils.addClass(this, 'ticking');
            Utils.addAnimationEndCallback(this._incoming, element => {
                Utils.removeClass(this, 'ticking');
                // swap content
                this._outgoing.replaceChildren(...this.#newContent);
                //this.#newContent = null;
            });
        };
    }
    #newContent;
    _tickContent(content = this.content) {
        if (typeof content === 'number') {
            content = content.toLocaleString();
        }
        if (typeof content === 'string') {
            const safeContent = this.sanitize(content);
            this.#newContent = this._buildMarkupNode(safeContent);
        }
        else if (content instanceof Node) {
            const safeContent = this.sanitize(content);
            this.replaceChildren(...(this.#newContent = [safeContent]));
        }
        else {
            const safeContent = content.map(a => this.sanitize(a));
            this.replaceChildren(...(this.#newContent = safeContent));
        }
    }
    _buildMarkupNode(html) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = html;
        return Array.from(tmpl.content.childNodes);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'content' && !first) {
            this._tickContent(val);
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._slot.addEventListener('slotchange', this._contentChangeHandler, false);
        const content = this.content ?? this._slot.assignedNodes();
        this._tickContent(content);
    }
    disconnectedCallback() {
        const slot = this._slot;
        if (!Utils.isNull(slot)) {
            slot.removeEventListener('slotchange', this._contentChangeHandler);
        }
        super.disconnectedCallback();
    }
};
__decorate([
    ViewChild('slot')
], PacemTickerElement.prototype, "_slot", void 0);
__decorate([
    ViewChild('div[part=ticker-outgoing]')
], PacemTickerElement.prototype, "_outgoing", void 0);
__decorate([
    ViewChild('div[part=ticker-incoming]')
], PacemTickerElement.prototype, "_incoming", void 0);
PacemTickerElement = __decorate([
    CustomElement({ tagName: P + '-ticker', shadow: true, template: `<div part="ticker-outgoing"></div><div part="ticker-incoming"></div><slot hidden></slot>` })
], PacemTickerElement);
export { PacemTickerElement };
